import { useEffect, useMemo, useState } from 'react';
import { buildUrlFromLocation } from '../../services/urls/common';
import env from '../../../config/environment';

const useIsomorphicCurrentUrl = () => {
  const [location, setLocation] = useState<Location>();

  useEffect(() => {
    setLocation(window.location);
  }, []);

  return useMemo(
    () =>
      buildUrlFromLocation(env.PUBLIC_CLIENT_BASE_URL || '', {
        pathname: location?.pathname || '',
        search: location?.search || '',
        hash: '',
      }),
    [location?.pathname, location?.search]
  );
};

export default useIsomorphicCurrentUrl;
